import mixin from 'utilities/mixin';
import ScrollCalc   from './scroll/calc';
import Timelag      from 'utilities/timelag';

export class ScrollUtil extends ScrollCalc {
  private preparedGetter: boolean = false;
  public getScrollWidth: () => number;
  public getContainerWidth: () => number;
  public getContentWidth: () => number;
  public lag:Timelag;
  public isPreparedGetter(): boolean {
    if(this.preparedGetter){ return true; }
    if(!this.getScrollWidth){ return false; }
    if(!this.getContainerWidth){ return false; }
    if(!this.getContainerWidth){ return false; }
    this.preparedGetter = true;
    this.updateContainerWidth(this.getContainerWidth());
    this.updateScrollWidth(this.getScrollWidth());
    this.updateContentWidth(this.getContentWidth());
    return true;
  }
  public setResizeEvent(callbackEventName: string){
    this.lag = new Timelag(() => { this.onResizeLagged(callbackEventName) }, 250);
    window.addEventListener('resize', (e) => { this.onResizeWindow(e) });
  }
  public onResizeWindow(e){
    if(!this.isPreparedGetter){ return; }
    this.lag.start();
  }
  public onResizeLagged(callbackEventName: string){
    this.updateContainerWidth(this.getContainerWidth());
    this.updateScrollWidth(this.getScrollWidth());
    this.updateScale();
    let customEvent = new CustomEvent(callbackEventName, {detail: this})
    document.dispatchEvent(customEvent);
  }
  public onChangePositionOfScroll(pos:number){
    this.calcContentPositionByScrollPosition(pos);
  }
  public onChangePositionOfContent(pos:number){
    this.calcContentPositionByScrollPosition(pos);
  }
  public data(){
    return this;
  }
  public isPrepared(){
    return this.isPreparedNatives();
  }
}
